import { render, staticRenderFns } from "./ServisneOperacijeServisneFakture.vue?vue&type=template&id=4efa2736&scoped=true&"
import script from "./ServisneOperacijeServisneFakture.vue?vue&type=script&lang=ts&"
export * from "./ServisneOperacijeServisneFakture.vue?vue&type=script&lang=ts&"
import style0 from "./ServisneOperacijeServisneFakture.vue?vue&type=style&index=0&id=4efa2736&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4efa2736",
  null
  
)

export default component.exports